import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import VisaFormService from "services/VisaFormService";

let initialState = { data: {} };

export const checkProjectId = createAsyncThunk(
  "checkProject/checkProjectId",
  async ({ smartCompanyID, projectID }) => {
    const response = await VisaFormService.checkProjectId({
      smartCompanyID,
      projectID,
    });
    return response?.results;
  }
);

export const checkProjectIdSlice = createSlice({
  name: "checkProject",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(checkProjectId, builder, ["data"]);
  },
});

export const selectCheckProjectId = (state) => state.checkProjectId;

export default checkProjectIdSlice.reducer;
